var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sms-code-container"},[_c('div',{staticClass:"btn-code",class:{ 'in-active': _vm.second > 0 },on:{"click":_vm.get_code}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }